import { useState } from "react";
import SectionCard from "../components/sectioncard";
import ToggleSwitch from "../components/toggle_switch";

export default function Settings() {
  const [accountSettings, setAccountSettings] = useState({ twoFA: false });
  const [notifications, setNotifications] = useState({ medReminders: true, appointment: true, healthTips: false });
  const [privacy, setPrivacy] = useState({ shareData: true });
  const [theme, setTheme] = useState("light");

  const saveSettings = () => {
    console.log({ accountSettings, notifications, privacy, theme });
    alert("Settings saved successfully!");
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <SectionCard title="Account Settings">
        <ToggleSwitch label="Two-Factor Authentication" checked={accountSettings.twoFA} onChange={() => setAccountSettings({...accountSettings, twoFA: !accountSettings.twoFA})} />
      </SectionCard>

      <SectionCard title="Notifications & Reminders">
        <ToggleSwitch label="Medication Reminders" checked={notifications.medReminders} onChange={() => setNotifications({...notifications, medReminders: !notifications.medReminders})} />
        <ToggleSwitch label="Appointment Notifications" checked={notifications.appointment} onChange={() => setNotifications({...notifications, appointment: !notifications.appointment})} />
        <ToggleSwitch label="Health Tips" checked={notifications.healthTips} onChange={() => setNotifications({...notifications, healthTips: !notifications.healthTips})} />
      </SectionCard>

      <SectionCard title="Privacy & Security">
        <ToggleSwitch label="Share Health Data with Doctors" checked={privacy.shareData} onChange={() => setPrivacy({...privacy, shareData: !privacy.shareData})} />
      </SectionCard>

      <SectionCard title="App Customization">
        <div className="flex items-center justify-between mb-4">
          <span>Theme</span>
          <select value={theme} onChange={(e) => setTheme(e.target.value)} className="border rounded-md px-3 py-2">
            <option value="light">Light</option>
            <option value="dark">Dark</option>
            <option value="system">System</option>
          </select>
        </div>
      </SectionCard>

      <button onClick={saveSettings} className="bg-indigo-500 text-white px-6 py-2 rounded-lg hover:bg-indigo-600 transition">
        Save Settings
      </button>
    </div>
  );
}
